export class IndicadoresVivosVModel {

    anio: number; // 2021,
    codigoArticulo: string; // "3031008",
    codigoCliente: string; // "100012",
    codigoVendedor: string; // "3113",
    contenedor: string; // "t02",
    dolares: number; // 100.0,
    isCorrect: boolean; // true,
    kilos: number; // 10.0,
    mes: number; // 8,
    nombreArticulo: string; // "TNP*220 LT AVG-100 (AC.VEG.AGR",
    nombreCliente: string; // "SEAFMAN C.A.",
    nombreVendedor: string; // "Moya Paredes Fabián Alberto",
    tipo: number; // 1,
    cajas: number; // "2"
    mtv: number;

    constructor() { }

    devolverGrid() {
        const obj: IndicadoresVivosVModelInterface = {
            anio: 'anio',
            codigoArticulo: 'codigoArticulo',
            codigoCliente: 'codigoCliente',
            codigoVendedor: 'codigoVendedor',
            contenedor: 'contenedor',
            dolares: 'dolares',
            isCorrect: 'isCorrect',
            kilos: 'kilos',
            mes: 'mes',
            nombreArticulo: 'nombreArticulo',
            nombreCliente: 'nombreCliente',
            nombreVendedor: 'nombreVendedor',
            tipo: 'tipo',
            cajas: 'cajas',
            mtv: 'mtv'
        }
        return obj;
    }

    devolverGridFacturasMarcas() {
        const obj: IndicadoresVivosVModeFacturasMarcaslInterface = {
            version: 'version',
            anio: 'anio',
            codigoArticulo: 'codigoArticulo',
            codigoCliente: 'codigoCliente',
            codigoVendedor: 'codigoVendedor',
            contenedor: 'contenedor',
            dolares: 'dolares',
            isCorrect: 'isCorrect',
            kilos: 'kilos',
            mes: 'mes',
            nombreArticulo: 'nombreArticulo',
            nombreCliente: 'nombreCliente',
            nombreVendedor: 'nombreVendedor',
            tipo: 'tipo',
            cajas: 'cajas',
            mtv: 'mtv'
        }
        return obj;
    }

    devolverGridGananciasVsIncentivos() {
        const obj: any = {
            tipoVendedorDescripcion: 'tipoVendedorDescripcion',
            variableDescripcion: 'variableDescripcion',
            tipoVendedorId: 'tipoVendedorId',
            variableId: 'variableId',
            cumplimiento: 'cumplimiento',
            ganancia: 'ganancia',
            cumplimientoFinal: 'cumplimientoFinal',
        }
        return obj;
    }

    devolverGridCarteras() {
        const obj: any = {
            idCartera: 'idCartera',
            anio: 'anio',
            mesInicio: 'mesInicio',
            mesFin: 'mesFin',
            tipoCarga: 'tipoCarga',
            idVendedor: 'idVendedor',
            nombreVendedor: 'nombreVendedor',
            valorInicial: 'valorInicial',
            valorFinal: 'valorFinal',
            cumplimiento: 'cumplimiento',
            mesDescripcion: 'mesDescripcion',
            mesInicioDescripcion: 'mesInicioDescripcion',
            mesFinDescripcion: 'mesFinDescripcion',
            error: 'error',
            correct: 'correct',
        }
        return obj;
    }

    devolverGriAsignacionDistribucion() {
        const obj: any = {
            tipoVendedorId: 'tipoVendedorId',
            variableId: 'variableId',
            valorPeso: 'valorPeso',
            fechaInicio: 'fechaInicio',
            fechaFin: 'fechaFin',
            descripcionTipoVendedor: 'descripcionTipoVendedor',
            descripcionVariable: 'descripcionVariable',
        }
        return obj;
    }

    devolverGriCargaInicialPromediosComision() {
        const obj: any = {
            idPromedio: 'idPromedio',
            anio: 'anio',
            mes: 'mes',
            codigoVendedor: 'codigoVendedor',
            promedio: 'promedio',
            nombreVendedor: 'nombreVendedor',
            mesDescripcion: 'mesDescripcion',
            variableId: 'variableId',
            variableDescripcion: 'variableDescripcion',
        }
        return obj;
    }
    

    devolverGricargaMetaIncentivoSellOut() {
        const obj: any = {
            idMetasIncentivo: 'idMetasIncentivo',
            anio: 'anio',
            mes: 'mes',
            tipoVendedorId: 'tipoVendedorId',
            vendedorId: 'vendedorId',
            kilos: 'kilos',
            ventas: 'ventas',
            tipoVendedorDescripcion: 'tipoVendedorDescripcion',
            nombreVendedor: 'nombreVendedor',
            mesDescripcion: 'mesDescripcion',
            nclientes: 'nclientes',
            codigoVendedor: 'codigoVendedor',
            cajas: 'cajas',
        }
        return obj;
    }

    devolverGriAsignacionDistribucionIncentivos() {
        const obj: any = {
            asignacionId: 'asignacionId',
            tipoAsignacion: 'tipoAsignacion',
            tipoVendedorId: 'tipoVendedorId',
            variableId: 'variableId',
            fechaInicio: 'fechaInicio',
            fechaFin: 'fechaFin',
            fechaInicioDDMMYYYY: 'fechaInicioDDMMYYYY',
            fechaFinDDMMYYYY: 'fechaFinDDMMYYYY',
            ganancia: 'ganancia',
            cumplimiento: 'cumplimiento',
            usuarioCarga: 'usuarioCarga',
            tipoVendedorDescripcion: 'tipoVendedorDescripcion',
            variableDescripcion: 'variableDescripcion',
            fechaCarga: 'fechaCarga',
            valorPeso: 'valorPeso',
            estado: 'estado',
            error: 'error',
            correct: 'correct',
        }
        return obj;
    }
}

export interface IndicadoresVivosVModelInterface {
    anio: string;
    codigoArticulo: string;
    codigoCliente: string;
    codigoVendedor: string;
    contenedor: string;
    dolares: string;
    isCorrect: string;
    kilos: string;
    mes: string;
    nombreArticulo: string;
    nombreCliente: string;
    nombreVendedor: string;
    tipo: string;
    cajas: string;
    mtv: string;
}

export interface IndicadoresVivosVModeFacturasMarcaslInterface {
    version: string;
    anio: string;
    codigoArticulo: string;
    codigoCliente: string;
    codigoVendedor: string;
    contenedor: string;
    dolares: string;
    isCorrect: string;
    kilos: string;
    mes: string;
    nombreArticulo: string;
    nombreCliente: string;
    nombreVendedor: string;
    tipo: string;
    cajas: string;
    mtv: string;
}